var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFigma({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.5V7.5H7.5V6.75C7.5 5.5095 8.5095 4.5 9.75 4.5H12V0H9.75C7.9604 0.00198514 6.24466 0.713781 4.97922 1.97922C3.71378 3.24466 3.00199 4.9604 3 6.75V7.5H0V12H3V19.5H0V24H10.5V19.5H7.5V12H15.042V19.5H12V24H22.5V19.5H19.5Z",
    fill: "white",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 4.5C18.4926 4.5 19.5 3.49264 19.5 2.25C19.5 1.00736 18.4926 0 17.25 0C16.0074 0 15 1.00736 15 2.25C15 3.49264 16.0074 4.5 17.25 4.5Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.20d6bc00.svg";
export { ForwardRef as ReactComponent };